import{SIZES as h}from"../../constants/sizes.js";var o;!function(h){h.h1="h1",h.h2="h2",h.h3="h3",h.h4="h4",h.h5="h5",h.h6="h6"}(o||(o={}));var r=h;export{r as HeadingSizes,o as HeadingTypes};
//# sourceMappingURL=LegacyHeadingConstants.js.map
